// Status colours with reserved meanings (good / warning / critical, plus gray for "couldn't
// check" and a lighter gray for "not checked yet"). Each one always sits next to its label in
// the legend, so colour never carries the meaning alone. Its own module so impact.js and
// StatusDonut.js can both use it without importing each other.
export const STATUS_COLORS = {
  good: "#0ca30c",
  warning: "#fab219",
  critical: "#d03b3b",
  neutral: "#a1a1aa",
  pending: "#e4e4e7",
};

// The middle size of issue in the impact donut: bigger than a warning-yellow one, short of red.
export const MEDIUM_COLOR = "#f2711c";
